import { useMemo } from "react";
export const useClassesInput = ({ name ='classes' , label ='' , options , defaultValue , disabled =false , shouldUnregister =false , icon  })=>useMemo(()=>({
            name,
            placeholder: label,
            options,
            defaultValue,
            isDisabled: disabled,
            menuVariant: 'floating',
            enableSearch: false,
            shouldUnregister,
            icon
        }), [
        defaultValue,
        disabled,
        label,
        name,
        options,
        shouldUnregister,
        icon
    ]);
export default useClassesInput;

//# sourceMappingURL=useClassesInput.js.map